import { render, staticRenderFns } from "./report-plan-cash.vue?vue&type=template&id=20ff72e3&scoped=true&"
import script from "./report-plan-cash.vue?vue&type=script&lang=ts&"
export * from "./report-plan-cash.vue?vue&type=script&lang=ts&"
import style0 from "./report-plan-cash.vue?vue&type=style&index=0&id=20ff72e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ff72e3",
  null
  
)

export default component.exports